module.exports = __webpack_public_path__ + "static/media/Generate_MRFS_16_Journal.4c976e16.svg";